import http from './base/http';

// 在职人员管理
export function formalUserList (data) {
  const params = { // http请求的参数
    SERVICE_ID: '10002',
    OTYPE: 4,
    USER_ID: parseInt(sessionStorage.getItem('userId')),
    SESSION: sessionStorage.getItem('session'),
    TC_ID: parseInt(sessionStorage.getItem('companyId')),
    ...data,
  };
  return http.post(params);
}
// 新增用户
export function addUser (data) {
  const params = {
    SERVICE_ID: '10002',
    OTYPE: 1,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    TC_ID: sessionStorage.getItem('companyId'),
    ...data,
  };
  return http.post(params);
}
// 修改用户
export function editUser (data) {
  const params = {
    SERVICE_ID: '10002',
    OTYPE: 3,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}
// 获取角色列表
export function getActor (data) {
  const params = { // http请求的参数
    SERVICE_ID: '10008',
    OTYPE: 3,
    USER_ID: parseInt(sessionStorage.getItem('userId')),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}
// 分配角色
export function submitActor (data) {
  const params = {
    SERVICE_ID: '10008',
    OTYPE: 1,
    USER_ID: parseInt(sessionStorage.getItem('userId')),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}
// 重置密码
export function changeUserPWD (data) {
  const params = {
    SERVICE_ID: '10008',
    OTYPE: 8,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}
// 禁用用户
export function stopUser (data) {
  const params = {
    SERVICE_ID: '10002',
    OTYPE: 2,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}
// 离职人员列表
export function temporaryUserList (data) {
  const params = { // http请求的参数
    SERVICE_ID: '10002',
    OTYPE: 5,
    USER_ID: parseInt(sessionStorage.getItem('userId')),
    SESSION: sessionStorage.getItem('session'),
    TC_ID: parseInt(sessionStorage.getItem('companyId')),
    ...data,
  };
  return http.post(params);
}
// 启用用户
export function startUser (data) {
  const params = {
    SERVICE_ID: '10002',
    OTYPE: 6,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}
// 获取项目点列表
export function getProject (data) {
  const params = {
    SERVICE_ID: '10010',
    OTYPE: 3,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    TC_ID: Number(sessionStorage.getItem('companyId')),
    ...data,
  };
  return http.post(params);
}
// 分配项目点权限
export function submitProject (data) {
  const params = {
    SERVICE_ID: '10010',
    OTYPE: 1,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}
// 获取供应商列表
export function getSupplier (data) {
  const params = {
    SERVICE_ID: '10011',
    OTYPE: 3,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    TC_ID: Number(sessionStorage.getItem('companyId')),
    ...data,
  };
  return http.post(params);
}
// 分配供应商权限
export function submitSupplier (data) {
  const params = {
    SERVICE_ID: '10011',
    OTYPE: 1,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}

// 账号导出
export function exportUserByActor (data) {
  const params = {
    SERVICE_ID: '10002',
    OTYPE: 20,
    TC_ID: Number(sessionStorage.getItem('companyId')),
    ...data,
  };
  return http.post(params);
}

// 获取角色列表
export function getAllActor (data) {
  const params = {
    SERVICE_ID: '10008',
    OTYPE: 6,
    ...data,
  };
  return http.post(params);
}



// WEBPACK FOOTER //
// ./src/api/userManager.js